import containerFuild from '../html-snippets/container-fuild.js';
import buttonPrimary from '@/views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/section-furnitureshop-specification.js';

const buttonHtml = buttonPrimary({
  show: false,
  text: 'BUY NOW',
  backgroundColor: '#FF8100',
  color: '#FFFFFF',
  radius: 4,
  iconPrefix: { show: false, src: '' },
  iconSuffix: { show: false, src: '' },
  subBtn: { show: false, text: '' },
});

const contentHtml = `
  <div
    class="furnitureshop-specification container"
    data-attribute="furnitureshop-specification"
    data-image-show="true"
    data-image-position="right"
  >
    <div
      class="furnitureshop-specification__info"
      data-attribute="furnitureshop-specification__info"
    >
      <div
        class="furnitureshop-specification__content"
        data-attribute="furnitureshop-specification__content"
      >
        <h2><span style="font-size:36px;"><strong>Specification</strong></span></h2>
        <p>Net Content: 100ml / 3.38fl.oz</p>
        <p>
          Main Ingredients: Water, Modified Amino Silicone Polymer,<br />
          Ethylene Copolymer, 1,2-Hexanediol, EDTA-2Na
        </p>
      </div>
      <div class="furnitureshop-specification__note">
        <div class="furnitureshop-specification__note-label">Note</div>
        <div
          class="furnitureshop-specification__note-content"
          data-attribute="furnitureshop-specification__note-content"
        >
          <p>
            Keep out of reach of children. Avoid contact with eyes.<br />
            Do not apply in direct sunlight or on hot surfaces.<br />
            Keep away from water for 24 hours after application.<br />
            Store in a cool, dry place and keep tightly sealed.
          </p>
        </div>
      </div>
      <div
        class="furnitureshop-specification__cta"
        data-attribute="furnitureshop-specification__cta"
      >
        ${buttonHtml}
      </div>
    </div>
    <figure
      class="furnitureshop-specification__media"
      data-attribute="furnitureshop-specification__media"
    >
      <img
        class="furnitureshop-specification__image"
        data-attribute="furnitureshop-specification__image"
        src="https://cdn.skyfastimg.com/images/2026/08/21/image-6a87b74ec7ac1e3a570c1530.webp?w=1000"
        alt="Crystal Serum"
      />
      <figcaption
        class="furnitureshop-specification__sub-text-image"
        data-attribute="furnitureshop-specification__sub-text-image"
      >
        Crystal Serum
      </figcaption>
    </figure>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#2A2A2A',
  textColor: '#FFFFFF',
});
